<template>
  <div>
    <div class="view-header">
      <h1 class="is-size-5 is-expanded">
        Leave Request
      </h1>
      <router-link
        :to="`/request/leave/edit/${$route.params.id}`"
        class="button is-small is-primary is-uppercase"
        >Edit</router-link
      >
    </div>
    <div class="box">
      <table class="table is-fullwidth">
        <tr>
          <th>Employee ID</th>
          <td>{{ leave.employeeId }}</td>
        </tr>
        <tr>
          <th>Name</th>
          <td>{{ leave.name }}</td>
        </tr>
        <tr>
          <th>Mobile</th>
          <td>{{ leave.mobile }}</td>
        </tr>
        <tr>
          <th>Email</th>
          <td>{{ leave.email }}</td>
        </tr>
        <tr>
          <th>From</th>
          <td>{{ leave.startDate | date }}</td>
        </tr>
        <tr>
          <th>To</th>
          <td>{{ leave.endDate | date }}</td>
        </tr>
        <tr>
          <th>Reason</th>
          <td>{{ leave.reason }}</td>
        </tr>
      </table>

      <div class="is-flex">
        <div class="is-expanded">
          <router-link to="/request/leave" class="button is-borderless"
            >Back</router-link
          >
        </div>
        <div class="is-expanded has-text-right"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      leave: {}
    };
  },
  mounted() {
    let component = this;
    component.$store
      .dispatch("leave/show", component.$route.params.id)
      .then(response => {
        component.leave = response.data;
      });
  }
};
</script>
